import React from 'react';
import { Chip } from '@mui/material';

const NavChip = ({ chip }) => {
    const fontSize = typeof chip.title === 'string' ? 10 : 11;
    return (
        <Chip
            label={chip.title}
            size="small"
            sx={{
                padding: 0,
                fontSize,
                fontWeight: 600,
                height: '26px',
                borderRadius: 2,
                backgroundColor: chip.bg,
                color: chip.fg,
                // wrap
            }}
            // wrap
        />
    );
};

export default NavChip;
